import React from "react";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import OutageCreateViewModel from "viewModels/administration/outages/outageCreateViewModel";
import CreateView from "../../common/create";
import OutageForm from "./outageForm";

const OutageCreateView: ViewComponent<OutageCreateViewModel> = observer(({ vm }) => (
  <CreateView vm={vm} form={<OutageForm vm={vm} />} />
));

registerView(OutageCreateView, OutageCreateViewModel);
